// Lazy module-level QueryClient singleton.
// Split out of QueryProvider.tsx so the .tsx file only exports React
// components (react-refresh/only-export-components rule).

import { QueryClient } from '@tanstack/react-query';
import { createQueryClient } from './client';

let singleton: QueryClient | null = null;

export function getSingletonClient(): QueryClient {
  if (singleton === null) {
    singleton = createQueryClient();
  }
  return singleton;
}

// Test-only: drops the cached client so each test that needs a fresh one
// can opt out without paying for explicit teardown.
export function __resetQueryProviderSingletonForTests(): void {
  singleton = null;
}
